import React from "react";
import {Button, styled, theme, Text} from "@reside/ui";
import {formatPermissionsManagementSelectedLabel} from "./permissionsManagementSelection.helpers";

type Props = Readonly<{
  selectedCount: number;
  isRemovingPermissions: boolean;
  onBulkEditPermissions: () => void;
  onRemoveAllPermissions: () => void;
}>;

export const PermissionsManagementBulkActionsBar = ({
  selectedCount,
  isRemovingPermissions,
  onBulkEditPermissions,
  onRemoveAllPermissions,
}: Props) => (
  <BulkActionsBar>
    <SelectedCount>
      {formatPermissionsManagementSelectedLabel(selectedCount)}
    </SelectedCount>
    {selectedCount > 1 && (
      <BulkEditLink type="button" onClick={onBulkEditPermissions}>
        Bulk edit permissions
      </BulkEditLink>
    )}
    <Button
      color="danger"
      disabled={isRemovingPermissions}
      outline
      size="small"
      onClick={onRemoveAllPermissions}
      testId="permissionsManagement-removeAllPermissions"
    >
      {isRemovingPermissions ? "Removing..." : "Remove all permissions"}
    </Button>
  </BulkActionsBar>
);

const BulkActionsBar = styled.div`
  align-items: center;
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
`;

const SelectedCount = styled(Text)`
  color: ${theme.color.darkBlue100};
  font-size: 14px;
  font-weight: 600;
  line-height: 20px;
`;

const BulkEditLink = styled.button`
  background: transparent;
  border: none;
  color: ${theme.color.primary};
  cursor: pointer;
  font-family: Gilroy, sans-serif;
  font-size: 16px;
  font-weight: 500;
  line-height: 20px;
  padding: 0;
  text-decoration: underline;

  &:hover {
    opacity: 0.85;
  }
`;
